<div class="hero">
  <div class="hero-bg"></div>
  <div class="hero-content">
    <h1>&nbsp;<!-- FÜR BESSERE --></h1>
    <div class="subline">
        <!-- <h1 class="headline">{{ 'RESERVATIONS.RESERVATION_SUCCESSFUL' | translate }}</h1> -->
        {{ 'RESERVATIONS.RESERVATION_SUCCESS_INFO' | translate }}
    </div>
    <button mat-raised-button color="primary" id="reservierungsbutton" class="cta" routerLink="/rent-duration" (click)="onStartReserve()">
      {{ 'GENERAL.START_SKI_RESERVATION' | translate }}
    </button>
  </div>
</div>
